import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';
// import { getFirestore } from 'firebase/firestore';
// import { getFirestore } from "firebase/firestore";

import { getStorage } from "firebase/storage";


  
// const firebaseConfig = {
//     apiKey: "AIzaSyAx8f4M5b70awRH0Vcsuc4mCM5gM6CpSW0",
//     authDomain: "stoi-trial.firebaseapp.com",
//     databaseURL: "https://stoi-trial-default-rtdb.firebaseio.com",
//     projectId: "stoi-trial",
//     storageBucket: "stoi-trial.appspot.com",
//     messagingSenderId: "509970927652",
//     appId: "1:509970927652:web:ce0ebeadee32339c06c8b1",
//     measurementId: "G-DNK34BHSLY"
//   };

const firebaseConfig = {
  apiKey: "AIzaSyAJdx6cQl6ZXVK4TLkCEPzGqp7IsVQc2Mg",
  authDomain: "stoi-data-collection.firebaseapp.com",
  databaseURL: "https://stoi-data-collection.asia-southeast1.firebasedatabase.app", //"https://stoi-data-collection-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "stoi-data-collection",
  storageBucket: "stoi-data-collection.appspot.com",
  messagingSenderId: "457834583012",
  appId: "1:457834583012:web:dae1192afff6006a20edf1"
};


 
  
var app = firebase.initializeApp(firebaseConfig);
var auth = app.auth();
var provider = new firebase.auth.GoogleAuthProvider(); 

// firebase.initializeApp(firebaseConfig);
var database = app.database();
var storage = getStorage(app);
// const firestore = getFirestore(app);


export {auth, provider, database, storage};
